import { useState, useCallback, useEffect } from 'react';

const STORAGE_KEY = 'jerico_nav_sections';

type SectionState = Record<string, boolean>;

export function useNavSections() {
  const [expandedSections, setExpandedSections] = useState<SectionState>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) return JSON.parse(stored);
    } catch { /* ignore */ }
    return {}; // all collapsed by default
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(expandedSections));
    } catch { /* ignore */ }
  }, [expandedSections]);

  const isExpanded = useCallback((sectionId: string) => {
    return !!expandedSections[sectionId];
  }, [expandedSections]);

  const toggleSection = useCallback((sectionId: string) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId],
    }));
  }, []);

  return { isExpanded, toggleSection };
}
